import {
  useGetDriverListQuery,
  useGetSchoolListQuery,
  useGetStudentListQuery,
  useGetTransporterListQuery,
} from "./Data/services/filterListApi";

const GlobalApiRefetcher = () => {
  // const dispatch = useDispatch();

  useGetTransporterListQuery(
    {},
    {
      // pollingInterval: 1 * 60 * 1000, // min * sec * msec
    }
  );

  useGetSchoolListQuery();

  useGetStudentListQuery();

  useGetDriverListQuery();

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   if (!token) return;

  // Fetch immediately
  // dispatch(filterListApi.endpoints.getTransporterList.initiate({}));

  // const interval = setInterval(() => {
  //   dispatch(
  //     filterListApi.endpoints.getTransporterList.initiate(
  //       {},
  //       { forceRefetch: false }
  //     )
  //   );
  // }, 5 * 60 * 1000);

  // return () => clearInterval(interval);
  // }, [dispatch]);

  return null;
};

export default GlobalApiRefetcher;
